// extracted by mini-css-extract-plugin
export var closeButton = "_1f-1";
export var container = "_1f-0";
export var fullModalImage = "_1f-2";